import { call, delay, put, select } from 'redux-saga/effects';
import {
    selectUA,
    selectRegisterer,
    selectAttemptingReconnect,
    selectReconnectionAttempt,
    selectOneSameServerReconnect,
    setUA,
    setUAState,
    setAttemptReconnect,
    incReconnectionAttempt,
    setOneSameServerReconnect
} from '../../../state/userAgent/userAgentSlice';
import { initUASaga } from '../initUA/initUA';
import { addRegistrarSaga } from '../addRegistrar/addRegistrar';
import { selectLogin } from '../../../state/login/loginSlice';
import { selectWsServers } from '../../../state/config/configSlice';


const RECONNECTION_DELAY = 4000; // 4 seconds
// const MAX_RECONNECTION_ATTEMPTS = 15; // max reconnection attempts

export function* attemptReconnectSaga() {
    const { isLoggedIn } = yield select(selectLogin);
    const attemptingReconnection = yield select(selectAttemptingReconnect);
    console.debug('attemptReconnect:', attemptingReconnection);
    if (!isLoggedIn || attemptingReconnection) {
        return;
    }
    //Attempting a reconnection
    yield put(setAttemptReconnect(true));
    let connected = false;
    // TODO: let attempts = 0; //uncomment this out to implement max reconnection attempt logic and allow reconnection on network online.
    TODO: while (!connected) { //comment this out to implement max reconnection logic.
        // TODO: while (!connected && attempts < MAX_RECONNECTION_ATTEMPTS) { //uncomment this out to implement max reconnection attempt logic.
        //TODO: attempts++; //uncomment this out to implement max reconnection attempt logic 
        const { isLoggedIn } = yield select(selectLogin);
        if (!isLoggedIn) { //To ensure no reconnect attempt when logged out.
            console.debug("Reconnect aborted: user logged out.");
            break;
        }
        yield delay(RECONNECTION_DELAY);
        yield put(setUAState('init'));
        const oneSameServerReconnectAvailable = yield select(selectOneSameServerReconnect);

        if (!oneSameServerReconnectAvailable) {
            yield put(incReconnectionAttempt());
            yield put(setOneSameServerReconnect(true));
        }
        const connectionAttempt = yield select(selectReconnectionAttempt);
        console.debug('Attempt Reconnect: connectionAttempt', connectionAttempt);

        const ua = yield select(selectUA);
        if (ua) {
            const wsServers = yield select(selectWsServers);
            const newServer = wsServers[connectionAttempt % wsServers.length];

            ua.transport.configuration.server = newServer;
            console.debug('Attempt Reconnect: new server', ua.transport.configuration.server);
            if (ua.state === 'Stopped') {
                try {
                    console.debug('Attempt Reconnect: stopped is starting...');
                    yield ua.start();
                    const hasRegisterer = yield select(selectRegisterer);
                    if (!hasRegisterer) {
                        console.debug('UA stoppped re-add Registrar');
                        yield call(addRegistrarSaga);
                    }
                    connected = true;
                    yield put(setAttemptReconnect(false));
                    yield put(setOneSameServerReconnect(true));
                } catch (e) {
                    yield put(setOneSameServerReconnect(false));
                    console.debug('Attempt Reconnect: failed to start', e);
                    yield put(setUA(null));
                }
            } else {
                try {
                    yield ua.reconnect();
                    console.debug('Attempt Reconnect: reconnect success!');
                    const hasRegisterer = yield select(selectRegisterer);
                    if (!hasRegisterer) {
                        console.debug('UA reconnecting re-add Registrar');
                        yield call(addRegistrarSaga);
                    }
                    connected = true;
                    yield put(setAttemptReconnect(false));
                    yield put(setOneSameServerReconnect(true));
                } catch (e) {
                    yield put(setOneSameServerReconnect(false));
                    console.debug('Attempt Reconnect: reconnect failed', e);
                    yield put(setUA(null));
                }
            }
        } else {
            console.debug('Attempt Reconnect: connectionAttempt ua = null calling initUA() to reset UA ');
            yield call(initUASaga);
        }
    }
    // TODO: yield put(setAttemptReconnect(false)); // This needs to be uncommented to implement MAX_RECONNECTION_ATTEMPTS coz as soon as attempts exceeds, we need to set attemptingReconnection as false after exiting while loop.
}